import React from "react";
import {Switch, Route} from "react-router-dom";

import SocialMediaProfile from 'components/LM/SocialMediaProfile/SocialMediaProfile';
import ExploreProfile from 'components/LM/SocialMediaProfile/ExploreProfile';

const SocialMedia = () => (
	<Switch>
		<Route path="/instagram/explore/:identifier" exact>
			<ExploreProfile type="instagram" typeName="profile"></ExploreProfile>
		</Route>
		<Route
			path="/:type(instagram|youtube|tiktok|facebook|twitter|douyin|weibo|wechat_public|bilibili|xiaohongshu)/profile"
			exact
			render={(props) => (
				<SocialMediaProfile type={props.match.params.type} typeName="profile" />
			)} />
	</Switch>
)

export default SocialMedia;
